module.exports = __webpack_public_path__ + "static/media/energy_card_blue_green.28ce04e0.svg";